import React from 'react';

interface NfceIconProps {
  /** Altura em px; a largura acompanha a proporção do selo. */
  size?: number;
}

/**
 * Selo "NFC-e" para o botão de emissão: a sigla é o que o operador reconhece,
 * mais do que um ícone genérico de recibo.
 */
export function NfceIcon({ size = 20 }: NfceIconProps): JSX.Element {
  return (
    <svg
      width={size * 2}
      height={size}
      viewBox="0 0 40 20"
      role="img"
      aria-label="NFC-e"
    >
      <rect
        x="1"
        y="1"
        width="38"
        height="18"
        rx="4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <text
        x="20"
        y="14.5"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="11"
        fontWeight="700"
        fill="currentColor"
      >
        NFC-e
      </text>
    </svg>
  );
}
